module.exports = __webpack_public_path__ + "static/img/buddy_mini_pictgrid10_800x690.746cf99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_mini_pictgrid10_800x690.jpg
// module id = htQ5
// module chunks = 0